import { getAxiosInstance } from "../ApiConfig";

async function getMyStaffRoles(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyStaffRole${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllStaffPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyStaffRole?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllStaffSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyStaffRole?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getSharedStaffRoles() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedStaffRole`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllStaffRoleByReportingUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllStaffRoleByReportingUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
} async function getByAddStaffRoleId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByAddStaffRoleId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteAddStaffRole(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteAddStaffRole/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createAddStaffRole(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAddStaffRole`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateAddStaffRole(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAddStaffRole/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createAddStaffRole,
    updateAddStaffRole,
    deleteAddStaffRole,
    getSharedStaffRoles,
    getMyStaffRoles,
    findAllStaffRoleByReportingUser,
    getByAddStaffRoleId,
    AllStaffPaginationSearch,
    AllStaffSearch,
}